<template>
  <div class="my_pagination_w">
    <el-pagination
      :current-page="currentPage_"
      :total="total_"
      style="margin-top: 8px"
      :layout="layout_"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :small="small"
      @current-change="_currentChange"
      @size-change="_sizeChange"
    />
  </div>
</template>

<script>
export default {
  props: {

    that: {
      type: Object,
      default: () => {}
    },
    small: {
      type: Boolean
    },
    currentPage: {
      type: Number,
      default: 0
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    total: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next, sizes, jumper'
    },
    changeMethodName: {
      type: String,
      default: ''
    },
    pageKey: {
      type: String,
      default: 'page'
    },
    rowKey: {
      type: String,
      default: 'rows'
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 50, 100]
    },
    pageInfo: {
      type: Object,
      default: () => {
        return {
          page: 1,
          rows: 10
        }
      }
    }

  },
  data() {
    return {
      // pageInfo: {
      //   page: 1,
      //   rows: 10
      // }
    }
  },
  computed: {
    total_: function() {
      return this.total
    },
    currentPage_: function() {
      return this.currentPage
    },
    layout_: function() {
      return this.layout
    }
  },

  methods: {

    _currentChange(val) {
      this.pageInfo[this.pageKey] = val
      if (this.changeMethodName) {
        this.that[this.changeMethodName](this.pageInfo)
      }
      this.$emit('current-change', val,)
    },
    _sizeChange(val) {
      this.pageInfo[this.pageKey] = 1
      this.pageInfo[this.rowKey] = val
      if (this.changeMethodName) {
        this.that[this.changeMethodName](this.pageInfo)
      }
      this.$emit('size-change', val,)
    }
  }
}
</script>
